import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MachineComponent } from './machine.component';
import { SalesComponent } from './sales/sales.component';
import { LogsComponent } from './logs/logs.component';
import { EventsComponent } from './events/events.component';
import { UpdatesComponent } from './updates/updates.component';
import { OpenIssuesComponent } from './open-issues/open-issues.component';
import { RemoteCtrlComponent } from './remote-ctrl/remote-ctrl.component';
import { MachineDetailsComponent } from './machine-details/machine-details.component';
import { RoleGuardService } from '../../../../app/core/_guard/role-guard.service';
import { FeatureFlagGuardService } from '../../../../app/core/_guard/feature-flag-guard.service';
import { SignalStrengthComponent } from './signal-strength/signal-strength.component';
import { ConnectionLogsComponent } from './connection-logs/connection-logs.component';
import { InventoryComponent } from './inventory/inventory.component';
import { InventoryLocationComponent } from './inventory-location/inventory-location.component';
import { SettingsComponent } from './settings/settings.component';
import { PriceChangeComponent } from './price-change/price-change.component';
import { CardReaderComponent } from './card-reader/card-reader.component';
import { MachineColdBrewComponent } from './cold-brew/machine-cold-brew.component';
import { AugerPurgeComponent } from './auger-purge/auger-purge.component';
import { CanisterTypeComponent } from './canister-type/canister-type.component';
import { RestocksComponent } from './restocks/restocks.component';


const genRoutes: Routes = [
  {path: '', component: MachineComponent, children: [
	{path: '', redirectTo: 'inventory', pathMatch: 'full'},
	{path: 'sales', component: SalesComponent},
	{path: 'logs', component: LogsComponent},
	{path: 'inventory', component: InventoryComponent},
	{path: 'location-inventory', component: InventoryLocationComponent},
	{path: 'restocks', component: RestocksComponent, canActivate: [RoleGuardService], data: {roles: ['sadmin']}},
	{path: 'events', component: EventsComponent},
	{path: 'updates', component: UpdatesComponent},
	{path: 'remote', component: RemoteCtrlComponent, canActivate: [RoleGuardService], data: {roles: ['sadmin', 'admin']}},
	{path: 'signal', component: SignalStrengthComponent},
	{path: 'conn-log', component: ConnectionLogsComponent},
	{path: 'details', component: MachineDetailsComponent, data: {roles: ['sadmin', 'admin']}},
	{path: 'open-issues', component: OpenIssuesComponent},
	{path: 'settings', component: SettingsComponent},
	{path: 'auger-purge', component: AugerPurgeComponent, canActivate: [RoleGuardService], data: {roles: ['sadmin']}},
	{
		path: 'canister-type',
		component: CanisterTypeComponent,
		canActivate: [RoleGuardService],
		data: {roles: ['sadmin']}
	},
	{path: 'price-change', component: PriceChangeComponent},
	{
		path: 'card-reader',
		component: CardReaderComponent,
		canActivate: [RoleGuardService, FeatureFlagGuardService],
		data: {roles: ['sadmin', 'marketadmin'], featureFlag: 'card_reader_registration'}
	},
	{path: 'cold-brew', component: MachineColdBrewComponent, canActivate: [RoleGuardService, FeatureFlagGuardService], data: {roles: ['sadmin'], featureFlag: 'cold_brew'}}
  ]}
];

@NgModule({
  imports: [
	RouterModule.forChild(genRoutes)
  ],
  exports: [
	RouterModule
  ]
})

export class MachineRoutingModule {
}
